<template>
  <header>
    <div>
      <template>
        <button id="menu-button" v-if="hasPaymentMethod" @click="openSidebar" :aria-label="$t('buttons.toggleSidebar')" :title="$t('buttons.toggleSidebar')" class="action">
          <i class="material-icons">menu</i>
        </button>

        <div v-if="($route.name === 'Files' || $route.name === ROUTES.BIN || $route.name === ROUTES.BACKUP || $route.name === 'Reg' || $route.name === ROUTES.CLOUD || $route.name === ROUTES.SECRET || $route.name === ROUTES.MY_SHARED_DRIVES || $route.name === ROUTES.SHARED_WITH_ME || $route.name === ROUTES.DRIVE || $route.name === ROUTES.ARCHIVED)" class="buscador">
          <input class="input" type="text" :placeholder="$t('buttons.search')" v-model="buscador"> 
          <button @click="showOrder" @mouseenter="mouseEnterMenu" @mouseleave="mouseLeaveMenu"> 
            <img src="/img/icons/other-stuff/filter.svg">
          </button>
          <nav id="menu-ordenacion" :style="menuStyleOrder">
            <div style="display: block; border-top: none;">
              <div class="option">
                <p>{{ $t('files.sortByName') }}</p>
                <div>
                  <button :title="$t('files.AtoZ')" @click="sort('-name')">
                    <img v-if="order === '-name'" src="/img/icons/other-stuff/arrow-down-circle-blue.svg">
                    <img v-else src="/img/icons/other-stuff/arrow-down-circle-black.svg">
                  </button>
                  <button :title="$t('files.ZtoA')" @click="sort('name')">
                    <img v-if="order === 'name'" src="/img/icons/other-stuff/arrow-up-circle-blue.svg">
                    <img v-else src="/img/icons/other-stuff/arrow-up-circle-black.svg">
                  </button>
                </div>
              </div>
              <div class="option">
                <p>{{ $t('files.sortByLastCreated') }}</p>
                <div>
                  <button :title="$t('files.oldestToRecent')" @click="sort('-ctime')">
                    <img v-if="order === '-ctime'" src="/img/icons/other-stuff/arrow-down-circle-blue.svg">
                    <img v-else src="/img/icons/other-stuff/arrow-down-circle-black.svg">
                  </button>
                  <button :title="$t('files.recentToOldest')" @click="sort('ctime')">
                    <img v-if="order === 'ctime'" src="/img/icons/other-stuff/arrow-up-circle-blue.svg">
                    <img v-else src="/img/icons/other-stuff/arrow-up-circle-black.svg">
                  </button>
                </div>
              </div>
              <div class="option">
                <p>{{ $t('files.sortByLastModified') }}</p>
                <div>
                  <button :title="$t('files.oldestToRecent')" @click="sort('-mtime')">
                    <img v-if="order === '-mtime'" src="/img/icons/other-stuff/arrow-down-circle-blue.svg">
                    <img v-else src="/img/icons/other-stuff/arrow-down-circle-black.svg">
                  </button>
                  <button :title="$t('files.recentToOldest')" @click="sort('mtime')">
                    <img v-if="order === 'mtime'" src="/img/icons/other-stuff/arrow-up-circle-blue.svg">
                    <img v-else src="/img/icons/other-stuff/arrow-up-circle-black.svg">
                  </button>
                </div>
              </div>
              <div class="option">
                <p>{{ $t('files.sortBySize') }}</p>
                <div>
                  <button :title="$t('files.lightestToHeaviest')" @click="sort('-size')">
                    <img v-if="order === '-size'" src="/img/icons/other-stuff/arrow-down-circle-blue.svg">
                    <img v-else src="/img/icons/other-stuff/arrow-down-circle-black.svg">
                  </button>
                  <button :title="$t('files.heaviestToLightest')" @click="sort('size')">
                    <img v-if="order === 'size'" src="/img/icons/other-stuff/arrow-up-circle-blue.svg">
                    <img v-else src="/img/icons/other-stuff/arrow-up-circle-black.svg">
                  </button>
                </div>
              </div>
            </div>
          </nav>
          <button v-if="!isBackup && (!isSharedDrive || (isSharedDrive && $route.hash !== ''))" @click.stop="toggleFilterTag"> 
            <img src="/img/icons/other-stuff/tag.svg">
          </button>
          <nav id="menu-tag" :style="menuStyleTag">
            <div style="display: block; border-top: none;">
              <h3>{{ $t('tag.tags') }}</h3>
              <div class="radio-buttons">
                <div class="radio-button">
                  <input type="radio" id=-1 value=-1 v-model="tag">
                  <label for=-1>{{ $t('tag.seeEverything') }}</label>
                </div>
                <div class="radio-button">
                  <input type="radio" id=0 value=0 v-model="tag">
                  <label for=0>{{ $t('tag.unset') }}</label>
                </div>
                <div class="radio-button">
                  <input type="radio" id=1 value=1 v-model="tag">
                  <label for=1>{{ $t('tag.personal') }}</label>
                </div>
                <div class="radio-button">
                  <input type="radio" id=2 value=2 v-model="tag">
                  <label for=2>{{ $t('tag.public') }}</label>
                </div>
                <div class="radio-button">
                  <input type="radio" id=3 value=3 v-model="tag">
                  <label for=3>{{ $t('tag.general') }}</label>
                </div>
                <div class="radio-button">
                  <input type="radio" id=4 value=4 v-model="tag">
                  <label for=4>{{ $t('tag.confidential') }}</label>
                </div>
                <div class="radio-button">
                  <input type="radio" id=5 value=5 v-model="tag">
                  <label for=5>{{ $t('tag.highConfidential') }}</label>
                </div>
              </div>
            </div>
          </nav>
        </div>

        <div>
          <button v-show="showSaveButton" :aria-label="$t('buttons.save')" :title="$t('buttons.save')" class="action" id="save-button">
            <i class="material-icons">save</i>
          </button>
          <manage-access v-if="showManageAccess && !isMobile && permissions === 0"></manage-access>
          <manage-spaces v-if="hasSecretsFeature && ($route.name === ROUTES.CLOUD || $route.name === ROUTES.SECRET) && !isMobile"></manage-spaces>
          <new-button v-if="((($route.name === ROUTES.CLOUD || $route.name === ROUTES.SECRET) && user.perm.create && !isMobile) || (($route.name === ROUTES.MY_SHARED_DRIVES || $route.name === ROUTES.SHARED_WITH_ME) && $route.hash !== '' && !isMobile && permissionsSharedDrive === 0) || ($route.name === ROUTES.DRIVE && permissionsSharedDrive === 0 && !isMobile)) && permissions === 0 && !isMaxStorage"></new-button>
          <upload-button v-if="((($route.name === ROUTES.CLOUD || $route.name === ROUTES.SECRET) && user.perm.create && !isMobile) || (($route.name === ROUTES.MY_SHARED_DRIVES || $route.name === ROUTES.SHARED_WITH_ME) && $route.hash !== '' && !isMobile && permissionsSharedDrive === 0) || ($route.name === ROUTES.DRIVE && permissionsSharedDrive === 0 && !isMobile)) && permissions === 0 && !isMaxStorage"></upload-button>
          <empty-trash v-if="($route.name === ROUTES.BIN) && req.items && req.items.length > 0 && permissions === 0"></empty-trash>

          <new-unit v-if="$route.name === ROUTES.MY_SHARED_DRIVES && !isMobile && permissions === 0 && !isMaxStorage"></new-unit>

          <button v-if="$route.name === ROUTES.BACKUP  && permissions === 0" :aria-label="$t('buttons.newCopy')" :title="$t('buttons.newCopy')" id="new-copy-button" class="action">
            <copy-icon size="1.2x" class="custom-class"></copy-icon>
            <p>{{ $t('buttons.newCopy') }}</p>
          </button>

          <template v-if="isTransfers && permissions === 0">
            <cancel-transfers-button v-if="showCancelTransfersButton"></cancel-transfers-button>
            <clear-completed-transfers-button v-else-if="showClearCompletedTransfersButton"></clear-completed-transfers-button>
          </template>
          
          <div style="position: relative;" v-if="($route.name !== ROUTES.SETTINGS && $route.name !== ROUTES.INVOICING && $route.name !== 'Invoicing Plans' && $route.name !== ROUTES.INFO && $route.name !== ROUTES.ACCOUNT && isLogged)">
            <button class="info-usuario" @click.stop="toggleUserInfo">
              <p>{{ this.userName }}</p>
            </button>
            <nav id="menu-info-user" :style="menuStyle">
              <div style="display: block;  padding-bottom: 10px;">
                <p class="name">{{ name }}</p>
                <p class="email">{{ userInfo.email }}</p>
                <router-link to="/profile/info" :title="$t('buttons.seeProfile')" :aria-label="$t('buttons.seeProfile')" class="action">
                  <user-icon size="1x" class="custom-class"></user-icon>
                  <span>{{ $t('buttons.seeProfile') }}</span>
                </router-link>
                <router-link to="/profile/settings" :title="$t('buttons.setting')" :aria-label="$t('buttons.setting')" class="action">
                  <settings-icon size="1x" class="custom-class"></settings-icon>
                  <span>{{ $t('buttons.setting') }}</span>
                </router-link>
                <router-link to="/profile/invoicing" :title="$t('buttons.planBilling')" :aria-label="$t('buttons.planBilling')" class="action">
                  <dollar-sign-icon size="1x" class="custom-class"></dollar-sign-icon>
                  <span>{{ $t('buttons.planBilling') }}</span>
                </router-link>
              </div>
            </nav>
          </div>
        </div>
      </template>

      <div v-show="showOverlay" @click="resetPrompts" class="overlay"></div>
    </div>
  </header>
</template>

<script>
import {mapGetters, mapState, mapMutations} from 'vuex';
import { logoURL } from '@/utils/constants';
import * as api from '@/api';
import buttons from '@/utils/buttons';
import { CopyIcon, UserIcon, SettingsIcon, DollarSignIcon } from 'vue-feather-icons';
import ManageSpaces from './buttons/ManageSpaces.vue';
import ManageAccess from './buttons/ManageAccess.vue';
import UploadButton from './buttons/Upload.vue';
import NewButton from './buttons/New.vue';
import EmptyTrash from './buttons/EmptyTrash.vue';
import NewUnit from './buttons/NewUnit.vue';
import ClearCompletedTransfersButton from './buttons/ClearCompletedTransfers.vue';
import CancelTransfersButton from './buttons/CancelTransfers.vue';
import { ROUTES } from '../router';


export default {
  name: 'header-layout',
  components: {
    CopyIcon,
    ManageSpaces,
    UserIcon,
    SettingsIcon,
    DollarSignIcon,
    UploadButton,
    NewButton,
    ClearCompletedTransfersButton,
    CancelTransfersButton,
    EmptyTrash,
    NewUnit,
    ManageAccess
  },
  data: function () {
    return {
      ROUTES,
      earnedMoney: '',
      showUserInfo: false,
      isShowOrder: false,
      isButtonOrder: false,
      showFilterTag: false,
      width: window.innerWidth,
      buscador: '',
      pluginData: {
        api,
        buttons,
        'store': this.$store,
        'router': this.$router
      },
      order: '-name',
      tag: -1,
    };
  },
  watch: {
    '$route': 'fetchData',
    buscador (val) {
      this.setSearchVal(val);
    },
    tag (val) {
      this.setFilterTag(val);
    }
  },
  computed: {
    ...mapGetters([
      'selectedCount',
      'isFiles',
      'isBackup',
      'isRegister',
      'isEditor',
      'isTransfers',
      'isListing',
      'isLogged',
      'isBin',
      'isSettings',
      'isCloud',
      'isSharedDrive',
      'isMaxStorage',
      'hasPaymentMethod',
      'hasSecretsFeature',
    ]),
    ...mapState([
      'req',
      'user',
      'loading',
      'reload',
      'multiple',
      'isMenu',
      'referrerCode',
      'isCodeVisible',
      'permissions',
      'permissionsSharedDrive',
      'userInfo',
      'accountInfo',
    ]),
    logoURL: () => logoURL,
    isMobile () {
      return this.width <= 768;
    },
    showOverlay () {
      return this.showMore;
    },
    menuStyle () {
      if (this.showUserInfo) {
        return {display: 'block'};
      } else {
        return {display: 'none'};
      }
    },
    menuStyleOrder () {
      if (this.isShowOrder) {
        return {display: 'block'};
      } else {
        return {display: 'none'};
      }
    },
    menuStyleTag () {
      if (this.showFilterTag) {
        return {display: 'block'};
      } else {
        return {display: 'none'};
      }
    },
    showUpload () {
      return this.isCloud && this.user.perm.create && !this.isMobile;
    },
    showManageAccess () {
      if (this.$route.name === ROUTES.MY_SHARED_DRIVES && this.$route.hash !== '' && this.req.nodeType === Module.NodeType.SHARED_DRIVE_ROOT.value) {
        return true;
      } else {
        return false;
      }
    },
    showSaveButton () {
      return this.isEditor && !this.isBackup && !this.isRegister && this.permissions === 0 && this.permissionsSharedDrive === 0;
    },
    showCancelTransfersButton () {
      if (!this.isTransfers || !this.req.items.length) {
        return false;
      }

      for (let i = 0; i < this.req.items.length; i++) {
        if (this.req.items[i].status != Module.TransferStatus.FINISHED.value) {
          return true;
        }
      }
      return false;
    },
    showClearCompletedTransfersButton () {
      if (!this.isTransfers || !this.req.items.length) {
        return false;
      }

      for (let i = 0; i < this.req.items.length; i++) {
        if (this.req.items[i].status == Module.TransferStatus.FINISHED.value) {
          return true;
        }
      }
      return false;
    },
    name() {
      return this.userInfo.firstname + ' ' + this.userInfo.lastname;
    },
    userName() {
      return this.userInfo.firstname.substr(0, 1) + this.userInfo.lastname.substr(0, 1);
    }
  },
  async mounted() {
    this.fetchData();
    window.addEventListener('click', this.hideUserInfo);
  },
  beforeDestroy () {
    window.removeEventListener('click', this.hideUserInfo);
  },
  methods: {
    ...mapMutations(['setReferrerCode', 'setSearchVal', 'setFilterTag']),
    async fetchData() {
      this.buscador = '';
    },
    hideUserInfo() {
      this.showUserInfo = false;
      this.showFilterTag = false;
    },
    mouseEnterMenu() {
      this.isButtonOrder = true;
    },
    mouseLeaveMenu() {
      this.isButtonOrder = false;
    },
    toggleUserInfo() {
      this.showUserInfo = !this.showUserInfo;
    },
    toggleFilterTag() {
      this.showFilterTag = !this.showFilterTag;
    },
    showOrder() {
      this.isShowOrder = !this.isShowOrder;
    },
    resetPrompts () {
      this.$store.commit('closeHovers');
    },
    openSidebar () {
      this.$store.commit('showHover', 'sidebar');
    },
    async sort (by) {
      let sortOrder = Module.SortOrderType.SORT_ORDER_DEFAULT.value;

      if (by === '-name') {
        sortOrder = Module.SortOrderType.SORT_ORDER_DEFAULT.value;
        this.order = '-name';
      } else if (by === 'name') {
        sortOrder = -Module.SortOrderType.SORT_ORDER_DEFAULT.value;
        this.order = 'name';
      } else if (by === '-ctime') {
        sortOrder = Module.SortOrderType.SORT_ORDER_CREATION_TIME.value;
        this.order = '-ctime';
      } else if (by === 'ctime') {
        sortOrder = -Module.SortOrderType.SORT_ORDER_CREATION_TIME.value;
        this.order = 'ctime';
      } else if (by === '-mtime') {
        sortOrder = Module.SortOrderType.SORT_ORDER_MODIFICATION_TIME.value;
        this.order = '-mtime';
      } else if (by === 'mtime') {
        sortOrder = -Module.SortOrderType.SORT_ORDER_MODIFICATION_TIME.value;
        this.order = 'mtime';
      } else if (by === '-size') {
        sortOrder = Module.SortOrderType.SORT_ORDER_SIZE.value;
        this.order = '-size';
      } else if (by === 'size') {
        sortOrder = -Module.SortOrderType.SORT_ORDER_SIZE.value;
        this.order = 'size';
      }

      this.$store.commit('setSortOrder', sortOrder);
      this.$store.commit('setReload', true);
    }
  }
};
</script>
